exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".report-explanation {\n  background-color: var(--color-warning);\n  height: 30px;\n  margin-bottom: 5px;\n  margin-left: 15px;\n  padding-top: 4px;\n  font-weight: bold;\n  font-size: 14px;\n  text-align: center;\n}\n", ""]);

